import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationGuard } from '@app/auth/authentication.guard';
import { EventModeGuard } from '@app/@core/guards/event-mode.guard';
import { ClientFirststartGuard } from '@app/@core/guards/client-firststart.guard';
import { SuperuserGuard } from '@app/@core/guards/superuser.guard';

import { PhutureLoginComponent } from './phuture-login/phuture-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardHomeComponent } from './dashboard/dashboard-home.component';
import { EventConfigComponent } from './event-config/event-config.component';
import { FirststartWorkshopFranceComponent } from './firststart/firststart.component';
import { FirststartFrenchRendezVousComponent } from './firststart-french-rendez-vous/firststart.component';
import { GalleryComponent } from './gallery/gallery.component';
import { TeaserComponent } from './teaser/teaser.component';

import { ProfileExhibitorComponent } from './profile-exhibitor/profile-exhibitor.component';

const routes: Routes = [
  // Redirect is driven at runtime by assets/config.json (event_finish flag).
  // Change that file on the server to switch modes — no rebuild needed.
  { path: '', pathMatch: 'full', canActivate: [EventModeGuard], component: PhutureLoginComponent },
  /*
  { dieser pfad wird nicht benötigt - denk ich
    path: '',
    canActivate: [],
    component: PhutureLoginComponent,
    data: { title: 'Atout' },
  },
  */
  {
    path: 'atout',
    canActivate: [],
    component: PhutureLoginComponent,
    data: { title: 'Atout' },
  },

  {
    path: 'gallery',
    canActivate: [EventModeGuard],
    component: GalleryComponent,
    data: { title: 'Gallery' },
  },

  {
    path: 'teaser',
    canActivate: [],
    component: TeaserComponent,
    data: { title: 'Teaser' },
  },

  {
    path: 'home',
    canActivate: [AuthenticationGuard],
    component: DashboardComponent,
    data: { title: 'Home' },
    children: [
      // Default main-area content (stats + tables)
      { path: '', component: DashboardHomeComponent },

      // Superuser-only Event Configuration (main area)
      {
        path: 'event-config',
        canActivate: [AuthenticationGuard, SuperuserGuard],
        component: EventConfigComponent,
        data: { title: 'Event Configuration' },
      },

      // Slide-over detail pages rendered in the named `detail` outlet
      { path: 'edit-wf', outlet: 'detail', component: FirststartWorkshopFranceComponent },
      { path: 'edit-frv', outlet: 'detail', component: FirststartFrenchRendezVousComponent },
      { path: 'exedit', outlet: 'detail', component: ProfileExhibitorComponent },
    ],
  },

  // Dispatcher: guard reads environment.client and redirects to -wf or -frv
  {
    path: 'firststart',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, ClientFirststartGuard],
    data: { wfRoute: '/firststart-wf', frvRoute: '/firststart-frv', title: 'Home' },
    component: FirststartWorkshopFranceComponent,
  },

  // Workshop France firststart
  {
    path: 'firststart-wf',
    canActivate: [AuthenticationGuard],
    component: FirststartWorkshopFranceComponent,
    data: { title: 'Home' },
  },

  // French Rendez-Vous firststart
  {
    path: 'firststart-frv',
    canActivate: [AuthenticationGuard],
    component: FirststartFrenchRendezVousComponent,
    data: { title: 'Home' },
  },

  {
    path: 'profile-exhibitor',
    canActivate: [], // AuthenticationGuard,AppDataSyncGuard
    component: ProfileExhibitorComponent,
    data: { title: 'Home' },
  },

  /*
    {
      path: 'settings',
      canActivate: [],
      component: SettingsComponent,
      data: { title: 'Settings' },
    },

    {
      path: 'datenschutz',
      canActivate: [],
      component: DatenschutzComponent,
      data: { title: 'Datenschutz' },
    },
    {
      path: 'impressum',
      canActivate: [],
      component: ImpressumComponent,
      data: { title: 'Impressum' },
    },
    */
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
